const EnergyMass=[
    {
        id:1,
        title:"Red Bull 0,25л",
        price:"120 грн",
        src: require('../img/redbull.webp'),
        text:"",
    },
    {
        id:2,
        title:"Red Bull tropical 0,25л",
        price:"120 грн",
        src: require('../img/rby.png'),
        text:"",
    },
    {
        id:3,
        title:"Red Bull sugarfree 0,25л",
        price:"120 грн",
        src: require('../img/rbws.png'),
        text:"",
    },
    
]

export default EnergyMass;